export default "__VITE_ASSET__DjnVKO7g__"